import { useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import { StyledTruncatedText } from 'components/StatisticsDataTable/StatisticsDataTable.styles';

export const isOverflowing = (el: HTMLElement | null): boolean =>
  !!el && el.scrollWidth > el.clientWidth;

interface TruncatedCellProps {
  value: string;
  textAlign?: 'left' | 'center';
  ml?: string;
}

export const TruncatedCell = ({ value, textAlign = 'center', ml }: TruncatedCellProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [truncated, setTruncated] = useState(false);

  if (!value) {
    return <StyledTruncatedText $textAlign={textAlign} $ml={ml} />;
  }

  const handleOpen = () => setTruncated(isOverflowing(ref.current));

  return (
    <Tooltip title={truncated ? value : ''} onOpen={handleOpen} enterDelay={400}>
      <StyledTruncatedText ref={ref} $textAlign={textAlign} $ml={ml}>
        {value}
      </StyledTruncatedText>
    </Tooltip>
  );
};
